import Size from './../types/Size'
import memoize from 'lodash.memoize'

const width: number = 150
const height: number = 217

const getCardSize = memoize(
    function getCardSize(innerWidth: number, innerHeight: number): Size {
        let scale = getScale(innerWidth, innerHeight)

        return {
            width: Math.round(width / scale),
            height: Math.round(height / scale),
        }
    },
    (innerWidth: number, innerHeight: number): string => {
        return String(innerWidth) + '-' + String(innerHeight)
    }
)

function getScale(innerWidth: number, innerHeight: number): number {
    const windowSize = Math.min(innerWidth, innerHeight)
    let scale = 1

    if (windowSize < 650) {
        scale = 1.5
    }
    if (windowSize < 450) {
        scale = 1.7
    }
    if (windowSize < 414) {
        scale = 2
    }
    if (innerHeight < 350) {
        scale = 2.5
    }
    if (innerWidth > innerHeight) {
        if (innerWidth > 600) {
            scale = height / (innerHeight / 3.5)
        } else {
            scale = height / (innerHeight / 3.7)
        }
    }
    return Math.max(1, scale)
}

export default (): Size => {
    const {innerWidth, innerHeight} = window
    return getCardSize(innerWidth, innerHeight)
}
